import * as React from 'react';
import snakeToPascal, { round } from '../../tools';
import { useAppStore } from '../../shared/stores/useAppStore';

export default function AuditabilityDataFloat({ data }) {
    const userSettings = useAppStore(s => s.userSettings);
    return (
        <div className="flex items-center justify-between py-1.5 px-3 bg-white rounded border border-slate-100">
            <span className="text-sm text-slate-600">{snakeToPascal(data.name)}</span>
            <span className="text-sm font-medium text-slate-900 tabular-nums">
                {round(data.value, 2).toLocaleString(userSettings.numberFormattingLocale)}
                {data.suffix && <span className="text-slate-500 ml-1">{data.suffix}</span>}
            </span>
        </div>
    );
}
